export const CREATE_FOLDERS_REQUEST = "CREATE_FOLDERS_REQUEST";
export const CREATE_FOLDERS_SUCCESS = "CREATE_FOLDERS_SUCCESS";
export const CREATE_FOLDERS_FAIL = "CREATE_FOLDERS_FAIL";